// extracted by mini-css-extract-plugin
export default {"logo-container":"models-module__logo-container--_06Mg","logo-svg":"models-module__logo-svg--xetB_","range-input":"models-module__range-input--RvTdD"};